module.exports = __webpack_public_path__ + "img/sponsorA29.9ea94373.png";